import { fromJS } from 'immutable';
import * as constants from './constants';
import R from 'ramda';

const initialState = fromJS({
  showPublicSignUpDialog: false,

  companyName: '',
  comments: [],
  hasMoreComments: true,
  postComment: {
    comment: '',
    postId: '',
    lastCommentId: '',
  },

  // file preview
  postFilePreview: {},
  postFiles: [],

  // loaders
  gettingPost: false,
  loadingComments: false,
});

export function publicPost(state = initialState, { type, payload }) {
  switch (type) {
    case constants.UPDATE_POST_PAGE_PROP:
      return state.merge(fromJS(payload));
    case constants.GET_POST_STARTED:
      return state.set('gettingPost', true);
    case constants.GOT_POST:
      return state.merge(fromJS(payload))
                  .set('hasMoreComments', payload.numOfComments > R.pathOr(0, ['comments', 'length'], payload))
                  .set('postFiles', R.pathOr([], ['post', 'files'], payload))
                  .set('gettingPost', false);
    case constants.GET_POST_FAILED:
      return state.set('gettingPost', false);
    case 'START_UPDATING_A_POST_NEWSFEED':
      if (payload.updateType === 'comment') {
        return state.update('comments', comments => comments.push(fromJS(R.merge(payload.updater.comment, { temporaryUuid: payload.temporaryUuid }))))
        .update('numOfComments', numOfComments => numOfComments + 1);
      }
      if (payload.updateType === 'deleteComment') {
        return state.update('comments', comments => comments.filter(comment => comment.get('_id') !== R.path(['updater', 'commentId'], payload)))
        .update('numOfComments', numOfComments => numOfComments - 1);
      }
      return state.merge(fromJS(payload.updater));
    case 'UPDATED_POST':
      if (payload.updateType === 'comment') {
        return state.update('comments', comments => {
          return comments.map(comment => {
            if (comment.get('temporaryUuid') === payload.temporaryUuid) return comment.set('_id', payload.response._id);
            return comment;
          });
        });
      }
      return state;
    case 'LOAD_MORE_COMMENTS_STARTED':
      return state.set('loadingComments', true);
    case 'LOAD_MORE_COMMENTS_FAILED':
      return state.set('loadingComments', false);
    case 'LOADED_MORE_COMMENTS':
      if (R.isEmpty(payload.comments)) {
        return state.set('loadingComments', false)
                    .set('hasMoreComments', false);
      }
      return state.set('loadingComments', false)
                  .update('comments', comments => fromJS(comments.toJS().concat(payload.comments)));
    case 'UPDATE_NEWSFEED_PROP':
      return state.merge(fromJS(payload));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/newsfeed/postPage/reducer.js